import React from "react";
import "../../../../stylesheets/components/Reports/HoldingReports/SmcasePopupFail.scss";
import { Link, useParams } from "react-router-dom";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
const SmcasePopupFailMob = (props) => {
    let url;
    const { loginOrigin } = useParams();
    const setUrl = (pathName) => {
        const destination = pathName +
            "?reportName=" +
            props.pageName.replace(/\s&/g, "") +
            (props.tabName ? "&tab=" + props.tabName : "");
        return destination;
    };
    return (React.createElement("div", { className: "mob-smallcase-popup-fail container" },
        React.createElement("div", { className: "mob-smallcase-popup-fail-body icon-100" },
            React.createElement("i", { className: "edel-icon-failure-popup icon" }, Array(7)
                .fill("")
                .map((i, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` })))),
            props.message ? (React.createElement("label", { className: "update-message" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: props.message } }))) : (React.createElement("label", { className: "update-message" },
                "We ran in to some technical difficulties with",
                props.operation == "email_download" ? " email/ download " : null,
                props.operation == "email" ? " email functionality " : null,
                props.operation == "download" ? " download functionality " : null,
                ", please try again!"))),
        React.createElement("span", { className: "action-post-success" }, !(props === null || props === void 0 ? void 0 : props.sendBack) ? (React.createElement(Link, { to: setUrl(getLoginSourceURL(loginOrigin)) },
            React.createElement("button", { onClick: () => {
                    props.closeDrawer();
                } },
                React.createElement("i", { className: "edel-icon-left-shortArrow twist" }),
                props.goBackText ? "Go Back" : `Go Back To ${props.pageName}`))) : (React.createElement("button", { onClick: () => {
                var _a, _b;
                (_a = props === null || props === void 0 ? void 0 : props.goBack) === null || _a === void 0 ? void 0 : _a.call(props);
                (_b = props === null || props === void 0 ? void 0 : props.closeDrawer) === null || _b === void 0 ? void 0 : _b.call(props);
                //  window.location.reload();
            } },
            React.createElement("i", { className: "edel-icon-left-shortArrow twist" }),
            props.goBackText ? "Go Back" : `Go Back To ${props.pageName}`)))));
};
export default SmcasePopupFailMob;
